module.exports = __webpack_public_path__ + "img/petstairs18.9070b952.jpg";